import { useLocation, useParams } from '@thd-olt-component-react/router';

export function usePreviewByID() {
  const { search } = useLocation();
  const params = useParams();
  const { '*': pathParams } = params;
  const idFromPathParams = pathParams?.split('/')[0];
  const searchParams = new URLSearchParams(search);
  const debugTrue = searchParams.get('debug');
  const idFromQueryParams = searchParams.get('previewByID');
  if (debugTrue === 'true' && (idFromPathParams || idFromQueryParams)) {
    return idFromPathParams || idFromQueryParams;
  }
  return null;
}